var map = {
	"./en/card_5_2.png": "4Xeb",
	"./es/card_5_2.png": "QY4+",
	"./pt/card_5_2.png": "rWW8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1xd3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/card_5_2\.png$
// module id = 1xd3
// module chunks = 0